<template>
  <div>
    <template v-for="productId in data">
      <b-tooltip
        v-if="
          prodById(productId).icon !== null && prodById(productId).name !== null
        "
        :key="productId"
        :label="prodById(productId).name"
        type="is-gold is-light"
      >
        <b-icon
          icon-pack="fas"
          :icon="prodById(productId).icon"
          :class="dataClass"
          :size="dataSize"
        ></b-icon>
      </b-tooltip>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'dataClass', 'dataSize'],
  computed: {
    ...mapGetters({ prodById: 'product/dataById' }),
  },
};
</script>
